<template>
  <div data-v-a632e678="" data-v-12b14801="" class="container download">
    <!---->
    <div data-v-a632e678="" class="row">
      <div data-v-a632e678="">
        <h3 data-v-a632e678="">APP下载</h3>
        <ul data-v-a632e678="" class="item">
          <li data-v-a632e678="" class="grup">
            <div data-v-a632e678="" class="item-group">
              <div data-v-a632e678="" class="item-img">
                <img data-v-a632e678="" src="/static/image/01.cf71e918.png" class="img-responsive" />
              </div>
              <div data-v-a632e678="" class="info">
                <h3 data-v-a632e678="">{{ $store.state.appInfo.title }}全新手机APP</h3>
                <p data-v-a632e678="">体验更好、速度更快、玩转社区</p>
              </div>
              <div data-v-a632e678="" class="item-btn"><span data-v-a632e678="" class="icon icon-ios"></span><span data-v-a632e678="" class="icon icon-android"></span><span data-v-a632e678="" id="appDown" @click="goApp" class="download-btn">下载</span></div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div data-v-a632e678="" class="row" v-if="false">
      <div data-v-a632e678="">
        <h3 data-v-a632e678="">真人娱乐</h3>
        <ul data-v-a632e678="" class="item">
          <li data-v-a632e678="" class="grup">
            <div data-v-a632e678="" class="item-group">
              <div data-v-a632e678="" class="item-img"><img data-v-a632e678="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/02.782a93fa.png" class="img-responsive" /></div>
              <div data-v-a632e678="" class="info">
                <h3 data-v-a632e678="">AG旗舰</h3>
                <p data-v-a632e678="">单注最高200万 豪客首选</p>
              </div>
              <div data-v-a632e678="" class="item-btn">
                <span data-v-a632e678="" class="icon icon-ios"></span><span data-v-a632e678="" class="icon icon-android"></span><span data-v-a632e678="" @click="downloadUrl($store.state.appInfo.ios_download_url)" id="appDown" class="download-btn">下载</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div data-v-a632e678="" class="row" v-if="false"><!----></div>
    <div data-v-a632e678="" class="row" v-if="false">
      <div data-v-a632e678="">
        <h3 data-v-a632e678="">体育竞技</h3>
        <ul data-v-a632e678="" class="item">
          <li data-v-a632e678="" class="grup">
            <div data-v-a632e678="" class="item-group">
              <div data-v-a632e678="" class="item-img"><img data-v-a632e678="" src="https://91a2c0front.dtbetter.com/cdn/91a2c0FM/static/img/shaba.17ee6afe.png" class="img-responsive" /></div>
              <div data-v-a632e678="" class="info">
                <h3 data-v-a632e678="">沙巴体育</h3>
                <p data-v-a632e678="">老牌权威 盘口齐全</p>
              </div>
              <div data-v-a632e678="" class="item-btn"><span data-v-a632e678="" class="icon icon-ios"></span><span data-v-a632e678="" class="icon icon-android"></span><span data-v-a632e678="" id="appDown" class="download-btn">下载</span></div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div data-v-434370a8="" data-v-a632e678="" class="dialog"><!----></div>
    <!---->
  </div>
</template>
<script>
export default {
  name: 'app',
  data() {
    return {};
  },
  created() {
    let that = this;
    that.getApp();
  },
  methods: {
    goApp() {
      let that = this;
      window.location.href = that.$store.state.appInfo.ios_download_url;
    },
    //下载文件
    downloadUrl(url) {
      let that = this;
      this.$parent.showLoading();

      const iframe = document.createElement('iframe');
      iframe.src = url;
      iframe.style.display = 'none'; // 防止影响页面
      iframe.style.height = 0; // 防止影响页面
      document.body.appendChild(iframe); // 必写，iframe挂在到dom树上才会发请求
      // 定时删除节点
      setTimeout(() => {
        that.$parent.hideLoading();

        document.body.removeChild(iframe);
      }, 2000);
    },
    getApp() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/app', {}).then(res => {
        if (res.code == 200) {
          //           ios_download_qrcode	string	分发下载二维码
          // ios_download_url	string	分发下载地址
          // h5_url	string	h5地址
          // "ios_download_qrcode": "http://mb2.tg-demo.cc:86/uploads/images/e13177382b3e958789c877f71b034ca9.jpg",
          // "ios_download_url": "http://mb2.tg-demo.cc:86/",
          // "h5_url": "http://mb2m.tg-demo.cc"
          localStorage.setItem('appInfo', JSON.stringify(res.data));
          that.$store.commit('changappInfo');
          that.$parent.hideLoading();
          document.getElementsByTagName('title')[0].innerText = that.$store.state.appInfo.title;
        }
      });
    },

  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
.img-responsive[data-v-a632e678] {
  width: 100%;
  max-width: 100%;
}
.download[data-v-a632e678] {
  padding: 20px 0 90px;
  background: #141414;
}
.download .row[data-v-a632e678] {
  margin-bottom: 15px;
}
.download .br[data-v-a632e678] {
  display: block;
  width: 100%;
  height: 1px;
  margin: 14px auto;
  background: #353535;
}
.row h3[data-v-a632e678] {
  padding: 0 15px;
  margin-bottom: 12px;
  font-size: 16px;
  color: #fff;
}
.row .item[data-v-a632e678] {
  padding: 14px 15px;
  background: #282828;
}
.row .item .item-img[data-v-a632e678] {
  display: inline-block;
  -ms-flex-preferred-size: 66px;
  flex-basis: 66px;
  width: 66px;
  padding: 0;
  margin-right: 10px;
  vertical-align: middle;
}
.row .item .grup[data-v-a632e678] {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 14px 0;
}
.row .item .grup + .grup[data-v-a632e678] {
  border-top: 1px solid #353535;
}
.row .item .grup[data-v-a632e678]:first-child {
  padding-top: 0;
}
.row .item .grup[data-v-a632e678]:last-child {
  padding-bottom: 0;
}
.row .item .info[data-v-a632e678] {
  display: inline-block;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  padding-right: 5px;
  vertical-align: middle;
}
.row .item .info h3[data-v-a632e678] {
  padding: 8px 0 0;
  margin-bottom: 5px;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  color: #fff;
}
.row .item .info p[data-v-a632e678] {
  font-size: 12px;
  line-height: 18px;
  color: #ccc;
}
.row .item .info p.txt2[data-v-a632e678] {
  font-size: 11px;
  color: #999;
}
.row .item .icon[data-v-a632e678] {
  position: relative;
  top: 0;
  display: inline-block;
  width: 15px;
  height: 18px;
  margin-right: 3px;
}
.row .item .icon-ios[data-v-a632e678] {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAeCAYAAADZ7LXbAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowZTUyOGI2Yy02YTYzLTRkZmMtYTJkOC1hY2UwM2VjYWZmYzgiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MjE1OUI0QkEwRTMyMTFFOEFEMjZFMTdCQ0M3MzlBMzQiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MjE1OUI0QjkwRTMyMTFFOEFEMjZFMTdCQ0M3MzlBMzQiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUuNSAoTWFjaW50b3NoKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOmE1NGE3YjlkLTNiMzUtNGQ1ZC1hMTE4LWE0NGRjNjJkNTg4OCIgc3RSZWY6ZG9jdW1lbnRJRD0iYWRvYmU6ZG9jaWQ6cGhvdG9zaG9wOmE1ZTQyMDZkLTEwYzAtMTE3Yi04YzlkLWNkZjVlODU3MDc3NSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PgKcJQEAAAHQSURBVHjatJbPK4RBGMffd0kpcpCUTW5+lJOLiIMSEiUUbmr/AMpBhIOEkttyUELcHBw4cMC6qM0eKEVEUg7CQX6uiO9Tz6sxzbur95156tPuuzszn/d9Z+Z5xo7FYpaPyAA9oANsgEFVo1QfglIeuICvV9waepXkgx2QI/y269Y44FEyIwn2wYFOSSFoFq4fQXeiDl4klcL3K1ADzhN18DIndOerIAKWwEuyDipJOugCjaAIxMERWANb/EnkgRBo4ZVmg2uwDRbAiTOgLe0TGngOBF1u6g7s8aRXgRSXdp9gEoyAb/FJQixINE80ePs/XimNOwQyQa8zYAWY9bGkVfHMT/07J2GQplFAr6vJkdCdl4MyS2+EHYEjabD0R1jejCWaBbSPLmRJtmbJvSqtPGmW5Mr7J8AbTGdQIauWJWcGJn5AlkQMSOpAnyg5BA8GRFNglDY8Sb7AsgEJZeVh2pROrpqnbGmZiagjOQbrBgTvYFrMuv3gw8C83IiSUzCmUUDjTagOEuNcYv3GK+gEbyoJrbRWMU17LFZtfC5wPRLRXdRzjY4LHRdBLacNKnbFXMPFjBvllLL5Zy0nOXBn8ankUhCqIsjV8Fb1548AAwCy7VzVDNuLFQAAAABJRU5ErkJggg==)
    no-repeat;
  background-size: cover;
}
.row .item .icon-android[data-v-a632e678] {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAeCAYAAADZ7LXbAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowZTUyOGI2Yy02YTYzLTRkZmMtYTJkOC1hY2UwM2VjYWZmYzgiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MTg2RjMwRUIwRTJBMTFFODlCRTBDQTg2Q0YzRTc4NzIiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MTg2RjMwRUEwRTJBMTFFODlCRTBDQTg2Q0YzRTc4NzIiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUuNSAoTWFjaW50b3NoKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOmE1NGE3YjlkLTNiMzUtNGQ1ZC1hMTE4LWE0NGRjNjJkNTg4OCIgc3RSZWY6ZG9jdW1lbnRJRD0iYWRvYmU6ZG9jaWQ6cGhvdG9zaG9wOmE1ZTQyMDZkLTEwYzAtMTE3Yi04YzlkLWNkZjVlODU3MDc3NSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PisUp+0AAAGsSURBVHja7JbNKwVRGMbPjBHhpq7/wEJW14JINgolJbLCCilKipKQZCd7yUq3bISSj5UV5avMQtkoWYobg4vcJB/PqVedTjNnzLljo3vq1z298/Y8Z+Y9573HsG2bKUYhSDL1yAVf4M0rwfQRqAK1PjkDoECVYPkI7IAZcACqQRnIAQlwCq5ooU46JgaJXoMil+dcvN9HQ/m58sA2GPYwYBRfAbO0oEAmWWAZNIEUfRp58GIfk/gomA5q0g2aaX4GplxyHsCgsKsmQGkQk15hXgk2XXKi4IRq9lPfriAm5UxvVPx2d2WDTk0Tx8skn0RvwBa9XbGmSUTYmR1Ut3UDbYUfuAZ6OATi4FHThG+SGBcGrRQb46uuF5LqWDhDbEWNpnSIzJBMRE0rLFHttpIx+b8mH9xkXwgchSQsXhz2eFtpAe3gnv6AIiGYtFGr4p1j1SLxeSHhmWJRDfFL+n0CC6qafIIecOFyzUlS03uV4i/gEIwHKfwGKAGLUjxGbzgixftADTjPnJM/N3GkK1CK5ndSXiIdkzm6W/HdMwluhY2xBt7BEthViXwLMAAhEVPmLJb0tgAAAABJRU5ErkJggg==)
    no-repeat;
  background-size: cover;
}
.row .item .download-btn[data-v-a632e678] {
  display: inline-block;
  width: 46px;
  height: 24px;
  margin: 0 0 0 5px;
  font-size: 12px;
  line-height: 24px;
  color: #cca352;
  text-align: center;
  border: 1px solid #c49b4f;
  border-radius: 4px;
}
.row .item .item-btn[data-v-a632e678] {
  display: inline-block;
  width: 92px;
  text-align: right;
  white-space: nowrap;
  vertical-align: middle;
}
.row .item-group[data-v-a632e678] {
  -ms-flex-pack: distribute;
  justify-content: space-around;
}
.row .item-buttons[data-v-a632e678],
.row .item-group[data-v-a632e678] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 100%;
}
.row .item-buttons[data-v-a632e678] {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 0 15px 20px;
  background: #282828;
}
.row .item-buttons .download-btn[data-v-a632e678] {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: inline-block;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 28px;
  margin-right: 14px;
  font-size: 14px;
  line-height: 28px;
  color: #fff;
  text-align: center;
  background: #cca352;
  border-radius: 4px;
}
.row .item-buttons .download-btn i[data-v-a632e678] {
  position: relative;
  top: 3px;
  display: inline-block;
  width: 16.5px;
  height: 16.5px;
  margin-right: 5px;
  background: url(/static/image/icon3.e723e484.png) no-repeat;
  background-size: 100% 100%;
}
.row .item-buttons .download-btn.download-btn2[data-v-a632e678] {
  margin-right: 0;
  color: #cca352;
  background: transparent;
  border: 1px solid #cca352;
}
.row .item-buttons .download-btn.download-btn2 i[data-v-a632e678] {
  background: url(/static/image/icon4.e2c494d8.png) no-repeat;
  background-size: 100% 100%;
}
.alertContent .alert-content[data-v-a632e678] {
  position: relative;
  width: 270px;
  overflow: hidden;
  background-color: #fff;
  border-radius: 6px;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.alertContent .alert-content .alert-title[data-v-a632e678] {
  padding-top: 20px;
}
.alertContent .alert-content .alert-title p[data-v-a632e678] {
  margin-bottom: 5px;
  font-size: 17px;
  font-weight: 700;
  line-height: normal;
  color: #000;
  text-align: center;
}
.alertContent .alert-content .alert-body[data-v-a632e678] {
  padding: 0 35px 20px;
  border-bottom: 1px solid #b2b2b2;
}
.alertContent .alert-content .alert-body p[data-v-a632e678] {
  font-size: 12px;
  line-height: 20px;
  color: #333;
  text-align: center;
}
.alertContent .alert-content .alert-footer[data-v-a632e678] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.alertContent .alert-content .alert-footer .alertbtn[data-v-a632e678] {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 44px;
  font-size: 17px;
  line-height: 44px;
  color: #007aff;
  text-align: center;
  cursor: pointer;
  background-color: #fff;
  border: none;
  outline: none;
}
.alertContent .alert-content .alert-footer .alertbtn[data-v-a632e678]:first-child {
  border-right: 1px solid #b2b2b2;
}
.popDownloadBackdrop[data-v-a632e678] {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
}
.popDownloadBackdrop .popDownload[data-v-a632e678] {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 298px;
  height: 200px;
  margin: auto;
  background: #fff;
  border: 1px solid #c79f5c;
  border-radius: 4px;
}
.popDownloadBackdrop .popDownload .pop-close[data-v-a632e678] {
  position: absolute;
  top: -35px;
  right: 0;
  width: 26px;
  height: 35px;
  background: url(/static/image/close.e8b8e7a1.png) no-repeat;
  background-size: 100% 100%;
}
.popDownloadBackdrop .popDownload .icon[data-v-a632e678] {
  position: absolute;
  top: -48px;
  right: 0;
  left: 0;
  width: 120px;
  height: 113px;
  margin: auto;
  background: url(/static/image/icon1.87539fd4.png) no-repeat;
  background-size: 100% 100%;
}
.popDownloadBackdrop .popDownload .pop-c[data-v-a632e678] {
  padding: 70px 16px 0;
  text-align: center;
}
.popDownloadBackdrop .popDownload .pop-c p[data-v-a632e678] {
  font-size: 16px;
  line-height: 22px;
  color: #666;
}
.popDownloadBackdrop .popDownload .pop-c .pop-buttons[data-v-a632e678] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  width: 100%;
  margin-top: 24px;
}
.popDownloadBackdrop .popDownload .pop-c .pop-buttons .pop-btn[data-v-a632e678] {
  position: relative;
  display: inline-block;
  width: 125px;
  height: 40px;
  font-size: 16px;
  line-height: 40px;
  text-align: center;
  border-radius: 3px;
}
.popDownloadBackdrop .popDownload .pop-c .pop-buttons .pop-btn.pop-btn1[data-v-a632e678] {
  width: 123px;
  height: 38px;
  line-height: 38px;
  color: #cca352;
  border: 1px solid #cca352;
}
.popDownloadBackdrop .popDownload .pop-c .pop-buttons .pop-btn.pop-btn2[data-v-a632e678] {
  color: #fff;
  text-shadow: 0 1px 1px rgba(50, 22, 0, 0.5);
  background: #ffd37c;
  background-image: linear-gradient(45deg, #ffd37c, #996b3d);
}
.popDownloadBackdrop .popDownload .pop-c .pop-buttons .pop-btn.pop-btn2 .tag[data-v-a632e678] {
  position: absolute;
  top: -1px;
  right: -1px;
  width: 32px;
  height: 32px;
  background: url(/static/image/tag.71449f13.png) no-repeat;
  background-size: 100% 100%;
}
.exclusive[data-v-a632e678] {
  width: auto;
  height: 18px;
  margin-left: 6px;
  vertical-align: text-bottom;
}
</style>



// WEBPACK FOOTER //
// src/components/main/app.vue